import styled from 'styled-components'
import { Box } from '@rebass/grid'

const Container = styled(Box)`
  width: 90%;
  max-width: 1110px;
  margin: 0 auto;
`

export default Container;